import { fromJS } from 'immutable';

import { createAsyncAction } from './../utils';

export const loadData = createAsyncAction('LOAD_ACTIVITY_DATA');
export const scrollLoad = createAsyncAction('ACTIVITY_SCROLL_LOAD');

const initialState = fromJS({
    loading: false,
    uploading: false,
    stopScroll: false,
    error: null,
    uploadError: null,
    activityTypes: [
        { key: 0, value: 'low' },
        { key: 1, value: 'medium' },
        { key: 2, value: 'high' }
    ],
    page: 1,
    count: 20,
    activityTypeIds: [0, 1, 2],
    activities: [],
    summary: null,
    timePeriod: null,
    projectIds: [],
    timePeriodInfo: { start: null, end: null }
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case loadData.REQUEST:
            return state
                .update('error', () => null)
                .update('loading', () => true)
                .update('timePeriod', () => fromJS(action.payload.timePeriod));
        case loadData.SUCCESS:
            return state
                .update('loading', () => false)
                .update('stopScroll', () => false)
                .update('page', () => action.payload.page)
                .update('count', () => action.payload.count)
                .update('projectIds', () => fromJS(action.payload.projectIds))
                .update('activityTypeIds', () => fromJS(action.payload.activityTypeIds))
                .update('timePeriod', () => fromJS(action.payload.timePeriod))
                .update('summary', () => fromJS(action.payload.summary))
                .update('activities', () => fromJS(action.payload.activities))
                .update('timePeriodInfo', () => fromJS(action.payload.timePeriodInfo));
        case loadData.FAIL:
            return state
                .update('loading', () => false)
                .update('error', () => action.payload);
        case scrollLoad.REQUEST:
            return state
                .update('uploadError', () => null)
                .update('uploading', () => true);
        case scrollLoad.SUCCESS:
            return state
                .update('uploading', () => false)
                .update('page', () => action.payload.page)
                .update('count', () => action.payload.count)
                .update('activities', activities => fromJS([...activities, ...action.payload.activities]))
                .update('stopScroll', () => action.payload.activities.length === 0);
        case scrollLoad.FAIL:
            return state
                .update('uploading', () => false)
                .update('uploadError', () => action.payload);
        default:
            return state;
    }
}

export function activityActions($http, api, $q) {
    'ngInject';
    const uri = `${api.restServiceUrlDB}Statistics/Projects/Activities`;
    function loadInitial({ projectIds, activityTypeIds, start, end, count, page, timePeriod }) {
        return dispatch => {
            dispatch({ type: loadData.REQUEST, payload: { timePeriod, projectIds }});
            return $http.post(`${uri}/${start}/${end}`, {
                projectIds,
                activityTypeIds,
                paging: { page, count, projectIds }
            }).then(response => {
                const { summery, activities } = response.data;
                const summary = summery;
                dispatch({
                    type: loadData.SUCCESS,
                    payload: {
                        summary,
                        activities,
                        projectIds,
                        activityTypeIds,
                        timePeriod,
                        timePeriodInfo: { start, end },
                        page,
                        count
                    }
                })
            }, error => {
                dispatch({ type: loadData.FAIL, error: true, payload: error.data });
            });
        }
    }

    function loadAdditional({ projectIds, activityTypeIds, start, end, count, page }) {
        return dispatch => {
            dispatch({ type: scrollLoad.REQUEST });
            return $http.post(`${uri}/${start}/${end}`, {
                projectIds,
                activityTypeIds,
                paging: { page, count, projectIds }
            }).then(response => {
                const { activities } = response.data;
                dispatch({ type: scrollLoad.SUCCESS, payload: { activities, page, count } });
            }, error => {
                dispatch({ type: scrollLoad.FAIL, error: true, payload: error.data });
            });
        }
    }

    return { loadInitial, loadAdditional };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/activity.js